import { cloneDeep } from 'lodash';

class BaseModel {
  // transform server data to instance
  transformServeDataToInstance(data) {
    Object.keys(this).forEach((key) => {
      this[key] = cloneDeep(data[key]);
    });
  }
}

export default BaseModel;
